import React, { useState, useEffect } from 'react';
import { isEmpty } from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import SystemMasterTabel from '../../Components/SystemMasterTabel/SystemMasterTabel';
import * as action from './Store/SystemMasters.action';
import ConfirmationPopup from '../../Components/ModalPopup/ConfirmationPopup';
import { useComponent } from '../UserSetting/UsersLibrary/UserRights';

const tempObj = {
  name: null,
  isEmpty: false,
  isNew: true,
  isActive: true,
  hasLength: false,
  _id: '',
};

function BrandMaster() {
  const dispatch = useDispatch();
  const reducer = useSelector((estate) => estate);
  const {
    SystemMastersDetails: { brandList, userAccessBrands },
    UserDetails: { userInfo },
    Users: { logInRights },
  } = reducer;
  const { CheckActionPermission } = useComponent();

  const MasterAddEditAccess = CheckActionPermission(logInRights, 'masters', 'brand', 'addEdit');
  const MasterDeleteAccess = CheckActionPermission(logInRights, 'masters', 'brand', 'delete');
  const { t } = useTranslation('common');
  const loggedInUserId = userInfo.userId;
  const loggedInUserRole = userInfo.role;
  const [isLoadingBrand, setIsLoadingBrand] = useState(false);
  const [showBrand, setShowBrand] = useState(false);
  const [isBrandUnique, setIsBrandUnique] = useState(true);
  const [buttonDownBrand, setButtonDownBrand] = useState(true);
  const [brandBtnDisable, setBrandBtnDisable] = useState(false);
  const [addingBrand, setAddingBrand] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showConfirmationAD, setShowConfirmationAD] = useState(false);
  const [isLoadingConf, setIsLoadingConf] = useState(false);
  const [isBrand, setIsBrand] = useState(false);
  const [brandData, setBrandData] = useState([]);
  const [isUniqBrandId, setIsUniqBrandId] = useState('');
  const [allowedBrandsId, setAllowedBrandId] = useState([]);
  const [deleteId, setDeleteId] = useState('');
  const [activeInactiveID, setActiveInactiveID] = useState('');

  useEffect(() => {
    if (userAccessBrands && !isEmpty(userAccessBrands)) {
      setAllowedBrandId(userAccessBrands?.map((element) => element?._id) || []);
    }
  }, [userAccessBrands]);

  useEffect(() => {
    setBrandData(brandList);
    if (addingBrand) {
      setBrandData([
        ...brandList,
        {
          name: null,
          isEmpty: false,
          isNew: true,
          isActive: true,
          _id: '',
          aliasName: '',
        },
      ]);
    }
  }, [brandList, addingBrand]);

  const callApi = async () => {
    setButtonDownBrand(!buttonDownBrand);
    setIsLoadingBrand(true);
    setShowBrand(buttonDownBrand);
    const brandParams = {
      accessedFrom: 'masters',
      loggedInUserId,
    };

    if (loggedInUserRole === 'User') {
      brandParams.isMaster = true;
      await dispatch(action.getuserBrandSDetails());
    }
    await dispatch(action.getBrandDetails(brandParams));

    setIsLoadingBrand(false);
  };

  const handleChanged = (event, i) => {
    const brands = [...brandData];
    setIsBrandUnique(true);
    setIsUniqBrandId([]);
    if (event.target.name === 'royaltyFee') {
      brands[i] = {
        ...brands[i],
        royaltyFee: event.target.value,
      };
    } else if (event.target.name === 'aliasName') {
      brands[i] = {
        ...brands[i],
        aliasName: event.target.value,
      };
    } else {
      brands[i] = {
        ...brands[i],
        name: event.target.value,
        isEmpty: event.target.value === '',
      };
    }

    const arr = [];
    const arrIndex = [];
    brands.forEach((ele, ind) => {
      brands.forEach((objs, index) => {
        if (ele.name === objs.name && ind !== index) {
          arr.push(ele);
          arrIndex.push(index);
        }
      });
    });
    if (!isEmpty(arr)) {
      const arrs = [...arrIndex];
      const removeArss = Math.min(...arrs);
      const newArr = arrIndex.filter((ele) => ele !== removeArss);
      setIsUniqBrandId([...newArr]);
    }
    setIsBrandUnique(isEmpty(arr));
    let isDisableBrand = false;
    brands.forEach((brandElement) => {
      if (isEmpty(brandElement?.name?.trim())) {
        isDisableBrand = true;
      }
    });
    setBrandBtnDisable(isDisableBrand);
    setBrandData(brands);
  };

  const addBrand = async () => {
    if (!showBrand) {
      setAddingBrand(true);
      setButtonDownBrand(!buttonDownBrand);
      setIsLoadingBrand(true);
      setShowBrand(buttonDownBrand);
      const brandParams = {
        accessedFrom: 'masters',
        loggedInUserId,
      };
      if (loggedInUserRole === 'User') {
        brandParams.isMaster = true;
        await dispatch(action.getuserBrandSDetails());
      }
      if (isEmpty(brandData)) await dispatch(action.getBrandDetails(brandParams));
      setIsLoadingBrand(false);
    } else if (!isEmpty(brandData)) {
      setBrandData([...brandData, tempObj]);
    } else {
      setBrandData([tempObj]);
    }
  };

  const handleDelete = (id) => {
    if (typeof id === 'number' || id === '') {
      brandData.splice(id, 1);
      let brandDel = false;
      brandData.forEach((brandElement) => {
        if (isEmpty(brandElement?.name?.trim())) {
          brandDel = true;
        }
      });
      setBrandBtnDisable(brandDel);
      setIsUniqBrandId([]);
      setIsBrandUnique(true);
      setBrandData([...brandData]);
    } else {
      setDeleteId(id);
      setShowConfirmation(true);
    }
  };

  const saveBrand = async () => {
    setIsBrand(true);
    if (!isEmpty(brandData)) {
      const emptyField = brandData.filter((britem) => britem.name === null || britem.name === '');

      if (isEmpty(emptyField)) {
        const data = brandData.map((brnobj) => {
          return {
            ...brnobj,
            name: brnobj?.name?.trim(),
            aliasName: brnobj?.aliasName ? brnobj.aliasName.trim() : '',
          };
        });
        const brandSaveParams = {
          title: t('BRAND_MASTER.BRAND'),
          names: JSON.stringify(data),
          loggedInUserId,
          showAlias: true,
        };
        setAddingBrand(false);
        await dispatch(action.saveToSystemMaster(brandSaveParams, t));
        const brandParams = {
          accessedFrom: 'masters',
          loggedInUserId,
        };
        setAddingBrand(false);
        if (loggedInUserRole === 'User') {
          brandParams.isMaster = true;
          await dispatch(action.getuserBrandSDetails());
        }
        await dispatch(action.getBrandDetails(brandParams));
      } else {
        const newState = brandData.map((brobj) => (brobj?.isEmpty === false && brobj.name === null ? { ...brobj, isEmpty: true } : brobj));
        setBrandData(newState);
      }
    }
    setIsBrand(false);
  };

  const activeInactiveClicked = (id) => {
    setShowConfirmationAD(true);
    setActiveInactiveID(id);
  };

  useEffect(() => {
    const array = [];
    brandData.forEach((ele, index) => {
      brandData.forEach((obj, places) => {
        if (index !== places && ele?.name === obj?.name) {
          array.push(ele);
        }
      });
    });
    if (isEmpty(array)) {
      setIsBrandUnique(isEmpty(array));
      setIsUniqBrandId([]);
    }
  }, [brandData]);

  const deleteConfirmed = async () => {
    setIsLoadingConf(true);
    const brandDeleteParams = {
      loggedInUserId,
      brandId: deleteId,
      title: t('BRAND_MASTER.BRANDS'),
    };
    await dispatch(action.deleteFromSystemMasters(brandDeleteParams, t));
    setBrandData([...brandList]);
    setIsLoadingConf(false);
    setShowConfirmation(false);
    const brandParams = {
      accessedFrom: 'masters',
      loggedInUserId,
    };
    if (loggedInUserRole === 'User') {
      brandParams.isMaster = true;
      await dispatch(action.getuserBrandSDetails());
    }
    await dispatch(action.getBrandDetails(brandParams));
  };

  const activeInactiveConfirmed = async () => {
    let brd = {};
    setIsLoadingConf(true);
    brandData.forEach((ele) => {
      if (ele._id === activeInactiveID) {
        ele.isActive = !ele.isActive;
        const data = {
          ...ele,
          loggedInUserId,
          title: t('BRAND_MASTER.BRANDS'),
        };
        brd = data;
      }
    });
    await dispatch(action.setActiveInactive(brd, t));
    setIsLoadingConf(false);
    setShowConfirmationAD(false);
    setBrandData([...brandData]);
  };

  return (
    <>
      <SystemMasterTabel
        isLoading={isLoadingBrand}
        setShow={showBrand}
        callApi={callApi}
        buttonDown={buttonDownBrand}
        mainData={brandData}
        handleChanged={handleChanged}
        addBtnClicked={addBrand}
        deletPressed={handleDelete}
        onSave={saveBrand}
        isDesabled={isBrand}
        title={t('BRAND_MASTER.MODAL_TITLE')}
        addLimit
        masterAddEditAccess={MasterAddEditAccess}
        masterDeleteAccess={MasterDeleteAccess}
        inputName="brand"
        activeInactiveClicked={activeInactiveClicked}
        btnDisable={brandBtnDisable}
        isUnique={isBrandUnique}
        isUniqueId={isUniqBrandId}
        allowedIds={allowedBrandsId}
        OpenReArrangeFunction
        showAlias
      />
      {showConfirmation && (
        <ConfirmationPopup
          onOpen={showConfirmation}
          onConfirm={() => deleteConfirmed()}
          title={t('BRAND_MASTER.DELETE_FROM_SYSTEM_MASTER')}
          message={t('BRAND_MASTER.ARE_YOU_SURE_DELETE_ITEM')}
          toggle={() => {
            setShowConfirmation(!showConfirmation);
          }}
          loading={isLoadingConf}
        />
      )}
      {showConfirmationAD && (
        <ConfirmationPopup
          onOpen={showConfirmationAD}
          onConfirm={() => activeInactiveConfirmed()}
          title={t('BRAND_MASTER.ACTIVATE_DEACTIVATE')}
          message={t('BRAND_MASTER.ARE_YOU_SURE_ACTIVATE_DEACTIVATE')}
          toggle={() => {
            setShowConfirmationAD(!showConfirmationAD);
          }}
          loading={isLoadingConf}
        />
      )}
    </>
  );
}
export default BrandMaster;
